<fi-detail-breadcrumb class="breadcrumb-box" number="{{ dateFormattedId }}"></fi-detail-breadcrumb>

<div class="container" [class.duplicate]="isDuplicateLead">
  <fi-info-side-bar
    [sideBarActive]="sideBarActive"
    [showDetails]="showDetails"
    [contactToDisplay]="linkedContactToDisplay"
    (onGetMainLead)="onGetMainLead()"
    (scrollToHistoryItem)="scrollToHistoryStart($event)"
    (onTabChanged)="selectedTabIndex = $event; onTabChange($event)"
    (onBrokeredTabSelected)="onBrokeredTabSelected($event)"
    (onNewLeadCreate)="openCreateLeadDialog($event)"
    [isDuplicateLead]="isDuplicateLead"
    [documents]="documents"
    [canEdit]="canEdit"
    [userId]="userId"
    [user]="user"
    [compendiumVisible]="!isDealerPartner"
    [selectedLeadId]="selectedLeadId"
    [selectedTabIndex]="selectedTabIndex"
    [openedLeads]="openedLeads"
    [brokeredLeads]="visibleBrokeredLeads"
    [brokeringSourceLead]="brokeringSourceLead"
    [brokeringParentLeadId]="brokeringParentLeadId"
    [showAddEnquiry]="showAddEnquiry"
    [leadCompendiumHasAccess]="leadCompendiumHasAccess"
    [companyContacts]="mainLeadDetails?.CompanyContacts"
    [connectedLeads]="mainLeadDetails?.ConnectedLeads"
    [linkedContacts]="selectedLeadDetails?.ConnectedContacts"
    [selectedLinkedContactId]="selectedLinkedContactId"
    [closedLeads]="closedLeads"
    [showLoadClosedLeads]="!!closedLeads?.length && !closedTabsOpened && !hideTabMore"
    [selectedLeadDetails]="selectedLeadDetails"
    [selectedLeadHistory]="selectedLeadHistory"
    [loadNewLeadEmailData]="loadNewLeadEmailData"
    >
  </fi-info-side-bar>

  <div class="main-content" [class.add-more-bottom-padding]="!!selectedLeadDetails?.Lead?.ExternalEmail">

    <fi-contact-type-card
      [userId]="userId"
      [selectedLeadDetails]="selectedLeadDetails"
      [addressToDisplay]="addressToDisplay"
      [constructionTypes]="constructionTypes"
      [isDealerPartner]="isDealerPartner"
      [isPremiumProjectPartner]="isPremiumProjectPartner"
      [canEdit]="canEdit"
      [consultationTypeName]="consultationTypeName"
      [selectedLinkedContactId]="selectedLinkedContactId"
      [selectedLeadId]="selectedLeadId"
      [ausschreibungstextes]="ausschreibungstextes"
      [broschures]="broschures"
      [cadDatens]="cadDatens"
      [musters]="musters"
      [contactToDisplay]="linkedContactToDisplay"
      [extendedProperties]="extendedProperties"
      (connectedContactClicked)="openContactDetails($event)"
      (leadUpdated)="onLeadUpdated($event)"
    ></fi-contact-type-card>

    @if (selectedLeadDetails?.Lead?.LeadTypeId === leadOfferType) {
      <fi-contact-order-card
        [selectedLeadDetails]="selectedLeadDetails"
        [userId]="userId"
        [mainOffer]="mainOffer"
        [mainOrder]="mainOrder"
        [selectedLeadId]="selectedLeadId"
        [extendedProperties]="extendedProperties"
        [contactToDisplay]="linkedContactToDisplay"
        [constructionTypes]="constructionTypes"
        [selectedLeadHistory]="selectedLeadHistory"
        [offerAmountCount]="offerAmountCount"
        [orderAmountCount]="orderAmountCount"
        [loadedLeadComposerOffers]="loadedLeadComposerOffers"
        (editOfferOrderActionRequested)="onEditOfferOrderActionRequested($event)"
        (editOfferOrderConstructionTypeIdUpdated)="onConstructionTypeIdUpdated($event)"
        (editOfferOrderLoadComposerOffersRequested)="onLoadComposerOffersRequested($event)"
      ></fi-contact-order-card>
    }

    <div class="item-row">
      <div class="detail-card remove-padding-on-mobile">
        <div class="mobile-padding">
          <div class="title-row">
            <div class="title" fiTranslation="REQUEST_DETAIL_HEADLINE_HISTORY"></div>
          </div>

          @if (canEdit) {
            <fi-editor
              (textChanged)="commentText = $event"
              (filesUploaded)="attachments = $event"
              (commentSubmitted)="onSendComment()"
              infoTooltipTranslation="ALT_TEXT_REQUEST_DETAIL_NOTE_INFO"
              [sending]="sendingComment">
            </fi-editor>
          }
        </div>

        @if (articlesLoaded) {
          <fi-brochure-sample
            [articles]="articles"
            [LeadTypeId]="selectedLeadDetails?.Lead?.LeadTypeId"
          ></fi-brochure-sample>
        }


        @if (visibleHistoryTabs.length) {
          <div class="comment-tab-container">
            <mat-tab-group matTabGroupSwipe [swipeLimitWidth]="20" [(selectedIndex)]="selectedCommentTabIndex" (selectedTabChange)="onCommentTabChange()">
              @for (historyTab of visibleHistoryTabs; track historyTab) {
                <mat-tab>
                  <ng-template mat-tab-label>
                    <span [fiTranslation]="historyTab"></span>
                  </ng-template>
                </mat-tab>
              }
            </mat-tab-group>
          </div>
        }

        @for (history of selectedLeadHistory; track history; let i = $index) {
          @if (history.ComposerChanges?.length) {
            <fi-history-comment
              [categoryIndex]="originalHistoryTabIndex"
              [canEdit]="canEdit"
              [composerChanges]="history.ComposerChanges"
              [isComposer]="true"
              [isDealerPartner]="isDealerPartner"
              [isPlanerUser]="!isDealerPartner"
              [isAdminUser]="isAdminUser"
              [leadExternalDesc]="selectedLeadDetails?.Lead.ExternalDesc"
              [history]="history"
              (brokeringTargetSelected)="onBrokeringTargetSelected($event)"
              >
            </fi-history-comment>
          }
          @if (!history.ComposerChanges?.length) {
            <fi-history-comment
              [categoryIndex]="originalHistoryTabIndex"
              [composerChanges]="[]"
              [history]="history"
              [leadExternalDesc]="selectedLeadDetails?.Lead.ExternalDesc"
              [eventAttendees]="selectedLeadDetails?.EventAttendees"
              [events]="selectedLeadDetails?.Events"
              [isComposer]="false"
              [canEdit]="canEdit"
              [contact]="leadContactToDisplay"
              [consentAccredation]="consentAccredation"
              [leadSerialNumber]="selectedLeadDetails?.Lead.SerialNumber"
              [leadInvoiceNumber]="selectedLeadDetails?.Lead.InvoiceNumber"
              [leadSourceText]="selectedLeadDetails?.Lead.LeadSourceText"
              [sourceDomain]="selectedLeadDetails?.Lead.SourceDomain"
              [isDealerPartner]="isDealerPartner"
              [isPlanerUser]="!isDealerPartner"
              [isAdminUser]="isAdminUser"
              [UTMParameters]="selectedLeadDetails?.Lead.UTMParameters"
              [referrerUrl]="selectedLeadDetails?.Lead.ReferrerUrl"
              [privacyDate]="selectedLeadDetails?.PrivacyDate!"
              [privacyText]="selectedLeadDetails?.PrivacyText"
              [privacyDocument]="selectedLeadDetails?.PrivacyDocument"
              (commentDeleted)="deleteHistoryItem(i)"
              (brokeringTargetSelected)="onBrokeringTargetSelected($event)"
              >
            </fi-history-comment>
          }
        }
        @if (relatedLeadsHistory.length && originalHistoryTabIndex === relatedLeadsHistoryTabIndex) {
          <fi-related-leads-history
            [history]="relatedLeadsHistory"
            >
          </fi-related-leads-history>
        }
      </div>
    </div>
  </div>


  <fi-contact-actions
    [userId]="userId"
    [isDuplicateLead]="isDuplicateLead"
    [loadedLeadComposerOffers]="loadedLeadComposerOffers"
    [mainLeadDetails]="mainLeadDetails"
    [mainLeadId]="mainLeadId"
    [selectedContact]="leadContactToDisplay"
    [selectedLeadDetails]="selectedLeadDetails"
    [selectedLeadId]="selectedLeadId"
    (actionRequested)="onActionRequested($event)"
    (duplicateChecked)="onDuplicateChecked()"
    (leadConnected)="onLeadConnected()"
    (actionCompleted)="onActionCompleted($event)"
  ></fi-contact-actions>

</div>



<fi-print-details
  [isOffer]="selectedLeadDetails?.Lead?.LeadTypeId === leadOfferType"
  [selectedLead]="selectedLeadDetails"
  [selectedLeadHistory]="selectedLeadHistory"
  [selectedContact]="leadContactToDisplay"
  [addressToDisplay]="addressToDisplay"
  [extendedProperties]="extendedProperties"
  [consultationTypeName]="consultationTypeName"
  [composerOrders]="composerOrders"
  [composerOffers]="composerOffers"
  [isPlanerUser]="!isDealerPartner"
  [isAdminUser]="isAdminUser"
  [mainOffer]="mainOffer"
  [mainOrder]="mainOrder"
  [articles]="articlesLoaded ? articles : undefined"
  [offerTotal]="offerAmountCount"
  [orderTotal]="orderAmountCount"
  [consentAccredation]="consentAccredation"
></fi-print-details>
